import React from "react";

import { Card, Nav, Container, Row, Col, Tab } from "react-bootstrap";
import { useSelector } from "react-redux";
import Pengajuan from "./Pengajuan";
import PengajuanSyariah from "./PengajuanSyariah";
import DetailPengajuan from "./TabPengajuan/indexSteps";

function IndexUser() {
  const pengajuan = useSelector((state) => state.pengajuanReducer);
  const auth = useSelector((state) => state.authReducer);
  const [status, setStatus] = React.useState("");
  const modalDetailPengajuan = useSelector((state) => state.pengajuanReducer);

  // React.useEffect(() => {
  //   setStatus(auth.role);
  // }, [auth.role]);
  return (
    <>
      {modalDetailPengajuan.modalDetailPengajuan ? (
        <>
          <Container fluid className="pt-3">
            <Row>
              <Col md="12">
                <Card
                  className="border-0 shadow-sm"
                  style={{ borderRadius: "20px", overflow: "hidden" }}
                >
                  {/* HEADER DENGAN JUDUL YANG INFORMATIF */}
                  <Card.Header className="bg-white border-0 pt-4 px-4">
                    <div className="d-flex align-items-center">
                      <div
                        style={{
                          width: "12px",
                          height: "30px",
                          backgroundColor: "#1D3557",
                          borderRadius: "10px",
                          marginRight: "15px",
                        }}
                      />
                      <Card.Title
                        as="h3"
                        style={{
                          color: "#1e293b",
                          textTransform: "uppercase",
                          fontWeight: "800",
                          margin: 0,
                          letterSpacing: "1px",
                        }}
                      >
                        Manajemen Pengajuan
                      </Card.Title>
                    </div>
                    <p
                      className="text-muted mt-2 ml-4"
                      style={{ fontSize: "14px" }}
                    >
                      Pantau dan proses seluruh berkas pengajuan kredit masuk.
                    </p>
                  </Card.Header>

                  <Card.Body className="px-4 pb-4">
                    <Tab.Container
                      id="pengajuan-tabs"
                      defaultActiveKey={
                        !pengajuan.lastTab ||
                        pengajuan.lastTab === "konvensional"
                          ? "konvensional"
                          : "syariah"
                      }
                    >
                      {/* NAVIGASI TAB PILLS: Responsive & Mewah */}
                      <div className="d-flex justify-content-center justify-content-md-start mb-4">
                        <Nav
                          variant="pills"
                          className="p-1 bg-light shadow-inner"
                          style={{
                            borderRadius: "15px",
                            display: "inline-flex",
                            border: "1px solid #e2e8f0",
                          }}
                        >
                          <Nav.Item>
                            <Nav.Link
                              eventKey="konvensional"
                              className="custom-nav-pill d-flex align-items-center"
                            >
                              <i className="fas fa-file-invoice mr-2"></i>
                              <span>KONVENSIONAL</span>
                            </Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link
                              eventKey="syariah"
                              className="custom-nav-pill d-flex align-items-center"
                            >
                              <i className="fas fa-file-invoice-dollar mr-2"></i>
                              <span>SYARIAH</span>
                            </Nav.Link>
                          </Nav.Item>
                        </Nav>
                      </div>

                      <Tab.Content className="mt-2 animation-fade">
                        <Tab.Pane eventKey="konvensional">
                          <Pengajuan />
                        </Tab.Pane>

                        <Tab.Pane eventKey="syariah">
                          <PengajuanSyariah />
                        </Tab.Pane>
                      </Tab.Content>
                    </Tab.Container>
                  </Card.Body>
                </Card>
              </Col>
            </Row>

            {/* STYLING KHUSUS UNTUK TAB PENGAJUAN */}
            <style>{`
    .custom-nav-pill {
      color: #64748b !important;
      font-weight: 800 !important;
      border-radius: 12px !important;
      padding: 10px 30px !important;
      transition: all 0.3s ease !important;
      background: transparent !important;
      font-size: 13px;
      letter-spacing: 0.5px;
    }
    
    .custom-nav-pill.active {
      background-color: #1D3557 !important;
      color: white !important;
      box-shadow: 0 4px 12px rgba(29, 53, 87, 0.25) !important;
    }

    .custom-nav-pill:hover:not(.active) {
      color: #1D3557 !important;
      background-color: #f1f5f9 !important;
    }

    .animation-fade {
      animation: fadeIn 0.4s ease-out;
    }

    @keyframes fadeIn {
      from { opacity: 0; transform: translateY(10px); }
      to { opacity: 1; transform: translateY(0); }
    }

    /* Responsive adjustments */
    @media (max-width: 576px) {
      .custom-nav-pill {
        padding: 10px 15px !important;
        font-size: 11px;
      }
      .nav-pills {
        width: 100%;
      }
      .nav-item {
        flex: 1;
        text-align: center;
      }
    }
  `}</style>
          </Container>
        </>
      ) : (
        <DetailPengajuan />
      )}
    </>
  );
}

export default IndexUser;
